export const ACTION_SHOW_CLAIM_FILE_DIALOG = 'ACTION_SHOW_CLAIM_FILE_DIALOG';
export const ACTION_SHOW_UNCLAIM_FILE_DIALOG = 'ACTION_SHOW_UNCLAIM_FILE_DIALOG';
export const ACTION_HIDE_CLAIM_UNCLAIM_FILE_DIALOG = 'ACTION_HIDE_CLAIM_UNCLAIM_FILE_DIALOG';

export const ACTION_CLAIM_FILE = 'ACTION_CLAIM_FILE';
export const ACTION_UNCLAIM_FILE = 'ACTION_UNCLAIM_FILE';
